import { useTheme } from 'foundations-theming/utils';
import { KOALA, BATTLESHIP } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';

/**
 * Represents an account in a remote app.
 * To display "the name" of an account, check the following properties:
 *   (1) `accountName` (possibly empty)
 *   (2) `accountIdentifier`
 *
 * Specific examples:
 *  - Activecampaign:
 *      accountName = "daffyduck" + accountIdentifier = "daffy@syncduck.com (subdomain: daffyduck)" -> "daffyduck"
 *
 *  - Netsuite:
 *      accountName = "" + accountIdentifier = "4309538_SB1" -> "4309538_SB1"
 *  (Netsuite doesn't expose human readable account names)
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ConnectedAccount({
  portalId,
  appId,
  account,
  error
}) {
  const trellisTheme = useTheme();
  const style = error ? {
    border: `1px solid ${trellisTheme.color['do-not-use-candy-apple']}`
  } : {};
  return /*#__PURE__*/_jsx(UIMediaObject, {
    "data-test-id": "universal-auth-account-avatar",
    style: style,
    className: "p-x-6 p-y-4",
    itemLeft: /*#__PURE__*/_jsx(UIIconCircle, {
      name: "contacts",
      color: BATTLESHIP,
      backgroundColor: KOALA,
      borderWidth: 0,
      size: 16
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "justify-between",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            textTransform: 'none'
          },
          children: account.accountName
        }), account.accountIdentifier !== '' && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: account.accountIdentifier
          })
        })]
      }), error && portalId && appId && /*#__PURE__*/_jsx("div", {
        className: "align-center",
        children: /*#__PURE__*/_jsx(UILink, {
          href: `/data-sync/${portalId}/app/${appId}/account/${account.id}`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "universalAuth.auth.viewAccountSettings"
          })
        })
      })]
    })
  });
}